import {
    getItemId,
    isDashboardFieldTarget,
    isDashboardFilterRule,
    type BaseFilterRule,
    type DashboardFilterableField,
} from '@lightdash/common';
import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';

export {
    getConditionalRuleLabel,
    getConditionalRuleLabelFromItem,
    getFilterOperatorOptions,
    getFilterOptions,
} from '@lightdash/common';

export const getFilterRuleTables = (
    filterRule: BaseFilterRule,
    field: DashboardFilterableField,
    filterableFields: DashboardFilterableField[],
    fieldsByTile?: Record<string, DashboardFilterableField[]>,
): string[] => {
    if (
        isDashboardFilterRule(filterRule) &&
        filterRule.tileTargets &&
        !isEmpty(filterRule.tileTargets)
    ) {
        return Object.entries(filterRule.tileTargets).reduce<string[]>(
            (tables, [tileUuid, tileTarget]) => {
                const targetField = (
                    fieldsByTile?.[tileUuid] ?? filterableFields
                ).find(
                    (f) =>
                        tileTarget !== false &&
                        isDashboardFieldTarget(tileTarget) &&
                        f.table === tileTarget.tableName &&
                        getItemId(f) === tileTarget.fieldId,
                );
                return targetField
                    ? uniq([...tables, targetField.tableLabel])
                    : tables;
            },
            [],
        );
    } else {
        return [field.tableLabel];
    }
};

export const formatDisplayValue = (value: string): string => {
    return value
        .replace(/^\s+|\s+$/g, (match) => '␣'.repeat(match.length))
        .replace(/\n/g, '↵');
};
